export async function buscaCep(cep,form)
{
  const validacep = /^[0-9]{5}-?[0-9]{3}$/;

  const _setValues = (logradouro, bairro) => {
    form.querySelector('input[data-buscacep="logradouro"]').value = logradouro;
    form.querySelector('input[data-buscacep="bairro"]').value = bairro;
  };
  
  const callbackSucesso = (dados) =>{
    _setValues(dados.logradouro, dados.bairro);
  };

  const callbackErro = (dados) =>{
  };

  if (typeof cep != 'undefined' && cep != '' && validacep.test(cep)){
    const response = await fetch('https://viacep.com.br/ws/' + cep + '/json/');
    if (response.status != 200) {
      callbackErro();
      return;
    }
    const jsonData = await response.json();
      if (jsonData.erro) {
          return;
      }
    callbackSucesso(jsonData);
  }
}
